// extracted by mini-css-extract-plugin
export default {"root":"NatRulesTableActions_root__g5m66","action":"NatRulesTableActions_action__l2XAJ","linkAction":"NatRulesTableActions_linkAction__A5xRe"};